import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavReport({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M15.03 11.88H2.38V2.96a.47.47 0 00-.47-.47H.97a.47.47 0 00-.47.47v9.84c0 .52.42.94.94.94h13.6c.25 0 .46-.21.46-.47v-.94a.47.47 0 00-.47-.46zm-.94-8.44h-3.46a.7.7 0 00-.5 1.2l.96.95-2.15 2.15-2.15-2.15a.94.94 0 00-1.33 0L3.45 7.6a.47.47 0 000 .66l.66.67c.19.18.48.18.67 0l1.34-1.35 2.15 2.15c.37.36.96.36 1.33 0l2.81-2.82.95.95a.7.7 0 001.2-.5V3.91c0-.26-.2-.47-.47-.47z" />
    </svg>
  );
}

SvgNavReport.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavReport.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavReport svgRef={ref} {...props} />);
export default ForwardRef;
